import {Injectable} from "@angular/core";
import { Data } from "@angular/router";
import {DataResponse, ListDataResponse} from "src/app/models/http.models";
import { Observable, Observer } from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {ComuniDto, NazioniDto} from "../../models/comuni.models";

@Injectable()

export class PlaceService extends BaseApiService{

  public getPlaceAutocomplete(nome: string, idProvincia?: number, idRegione?: number, soloPrincipali?: boolean, cessato?: boolean): Observable<DataResponse<ComuniDto>> {
    return this.httpService.get(`PortalsComuni/RicercaAutocomplete?nome=${encodeURIComponent(nome)}&idProvincia=${idProvincia}&idRegione=${idRegione}&soloPrincipale=${soloPrincipali}&cessato=${cessato}`);
  }

  public getNationAutocomplete(nome : string):Observable<DataResponse<NazioniDto>>{
    return this.httpService.get(`PortalsComuni/RicercaNazioni?nome=`+nome);
  }
}
